import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-template.component.html',
    styleUrls: ['./alert-template.component.scss']
})

export class AlertTemplateComponent implements OnInit, AfterViewInit {

    public message = '';
    public html: HTMLElement;
    public cancelButtonText;
    public showButtonAccept = true;
    public showButtonCancel = true;
    public loading = false;
    public titulo;
    public boldTitle;
    public form: any[];
    public formGroup: FormGroup;
    public functionToSave: any;
    public params;
    public responseMessage;
    public isContentCentered = false;
    public isPdfDocument = false;
    public fieldsToCheck: string[] = [];
    public imageSign: any;
    public labelButtonSave = 'Aceptar';
    public labelButtonCancel = 'Cancelar';
    public showPromotionText = false;
    dobDatePicker;

    public theme: 'light' | 'dark' = 'light';
    public size: 'compact' | 'normal' = 'normal';
    public lang = 'en';
    public type: 'image' | 'audio';

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<AlertTemplateComponent>,
        @Inject(DOCUMENT) private document: Document,
        private cdRef: ChangeDetectorRef) {

        if (data) {
            this.titulo = data.title;
            this.boldTitle = data.boldTitle;
            this.functionToSave = data.functionToSave;
            this.params = data.params;
            this.message = data.message || this.message;
            this.loading = data.loading;
            this.form = data.form;
            this.isContentCentered = data.isContentCentered;
            this.showButtonAccept = (typeof data.showButtonAccept !== 'undefined') ? data.showButtonAccept : true;
            this.showButtonCancel = (typeof data.showButtonCancel !== 'undefined') ? data.showButtonCancel : true;
            this.responseMessage = data.responseMessage;
            this.showPromotionText = data.showPromotionText;
            if (data.labelButtonSave) {
                this.labelButtonSave = data.labelButtonSave;
            }
            if (data.labelButtonCancel) {
                this.labelButtonCancel = data.labelButtonCancel;
            }
            if (data.buttonText) {
                this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
            }
            if (data.isPdfDocument) {
                this.html = data.html;
                this.isPdfDocument = data.isPdfDocument;
                this.fieldsToCheck = data.fieldsToCheck;
                this.imageSign = data.imageSign;
            }
        }

        this.dialogRef.updateSize('300vw', '300vw');
    }
    ngAfterViewInit(): void {
        if (this.form) {
            this.addEvents();
        }
    }

    addNumber(name: string): void {
        const valueInput = this.formGroup.get(name).value;
        if (valueInput < 3) {
            this.formGroup.get(name).setValue(valueInput + 1);
        }
    }

    removeNumber(name: string): void {
        const valueInput = this.formGroup.get(name).value;
        if (valueInput > 1) {
            this.formGroup.get(name).setValue(valueInput - 1);
        }
    }

    ngOnInit(): void {
        if (this.form) {
            // console.log('el formulario es', this.form);
            this.buildFormGroup(this.form);
        }
        if (this.isPdfDocument) {
            this.cdRef.detectChanges();
            const element = document.getElementById('pdfDocument');
            element.appendChild(this.html);
        }
    }

    addEvents(): void {
        this.form.forEach(element => {
            if (element.event) {
                const doc = document.getElementById(element.name);
                if (doc) {
                    doc.addEventListener(element.typeEvent, () => {
                        this.eventExecuted(element, doc);
                    });
                }

            } else if (element.element === 'list') {
                element.list.forEach(li => {
                    const doc = document.getElementById(li.name);
                    if (doc) {
                        doc.addEventListener(li.typeEvent, () => {
                            this.eventExecuted(li, doc);
                        });
                    }
                });
            }
        });
    }

    eventExecuted(element: any, documento: any): void {
        element.event(this.form, this.formGroup, element, documento)
            .then(response => {

            });
    }

    buildFormGroup(form: any): void {
        const formTemp: any = {};
        form.forEach(element => {
            if (!element.list) {
                formTemp[element.name] = new FormControl((element.value) ? element.value : '', element.validations);
            } else {
                element.list.forEach(li => {
                    formTemp[li.name] = new FormControl((li.value) ? li.value : '', li.validations);
                });

            }
        });

        this.formGroup = new FormGroup(formTemp);
        // console.log('el formGroup es', this.formGroup);
    }

    guardarForm(): void {
        // console.log('ejecutamos', this.formGroup, ' ', this.params);
        this.functionToSave(this.formGroup, this.form, this.params)
            .then(x => {
                const response = { object: x, message: this.responseMessage };
                this.onConfirmClick(response);
            })
            .catch(x => {
                // console.log('hubo un error al guardar ', x);
                this.onConfirmClick('hubo un error al guardar ' + x);
            });
    }

    onConfirmClick(valueTosend?: any): void {
        if (valueTosend) {
            this.dialogRef.close(valueTosend);
        } else {
            this.dialogRef.close(true);
        }
    }

    printDocument(): void {
        console.log('vamos a ver el documento');
        if (this.fieldsToCheck.length > 0) {
            let flag = true;
            this.fieldsToCheck.forEach(field => {
                const input: any = (this.html.getElementsByClassName(field)[0]);
                const excluyente = input.getAttribute('data-excluyente');
                if (excluyente) {
                    flag = flag && this.verifyExcluyente(input, excluyente);
                } else {
                    const valueType = (input.type === 'text') ? (input.value && true) ? true : false :
                        (input.type === 'checkbox') ? (input.checked) ? true : false : false;
                    if (valueType) {
                        flag = flag && true;
                    } else {
                        flag = false;
                    }
                }
            });
            if (flag) {
                const objToSend = { html: this.html };
                this.dialogRef.close(objToSend);
            } else {
                this.dialogRef.close({});
            }
        } else {
            if (this.imageSign) {
                const input: any = (this.html.getElementsByClassName(this.imageSign)[0]);
                const valueSrc = (input.alt === 'Signed') ? input.src : undefined;
                // console.log('el valor de la firma es ', valueSrc);
                if (valueSrc) {
                    const objToSend = { html: this.html, signImage: valueSrc };
                    this.dialogRef.close(objToSend);
                } else {
                    this.dialogRef.close({});
                }
            } else {
                const objToSend = { html: this.html };
                this.dialogRef.close(objToSend);
            }
        }
    }

    verifyExcluyente(input: any, excluyente: any): boolean {
        const excl: any = (this.html.getElementsByClassName(excluyente)[0]);
        if (input.type === 'checkbox') {
            if (input.checked) {
                excl.removeAttribute('checked');
                return true;
            } else if (excl.checked) {
                input.removeAttribute('checked');
                return true;
            } else {
                return false;
            }
        } else if (input.type === 'text') {
            if (input.value) {
                return true;
            } else if (excl.value) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    handleSuccess(data): void {
        console.log(data);
    }
}
